import React, { ReactNode } from 'react';
import { Steps } from 'antd';
import { StepProps as StepCopyProps } from 'antd/lib/steps';

export type StepProps = StepCopyProps & {
  children?: ReactNode;
};

const ProSteps: React.FC<StepProps> = (props) => {
  const { children, ...resProps } = props;

  return (
    <Steps.Step {...resProps}>
      {children}
    </Steps.Step>
  );
};

export default ProSteps;
